import script from "./Pa12ModelList.vue?vue&type=script&setup=true&lang=js"
export * from "./Pa12ModelList.vue?vue&type=script&setup=true&lang=js"

import "./Pa12ModelList.vue?vue&type=style&index=0&id=5617c179&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5617c179"]])

export default __exports__